import 'react-day-picker/style.css'
import { DayPicker, type DayPickerProps } from 'react-day-picker'
import { cn } from '@/lib/utils'

/**
 * A month calendar (react-day-picker) styled to the design system via the
 * `.ds-calendar` overrides in index.css. Thin wrapper — pass `mode`, `selected`,
 * `onSelect`, etc. straight through.
 */
export function Calendar({ className, ...props }: DayPickerProps) {
  return <DayPicker showOutsideDays className={cn('ds-calendar', className)} {...props} />
}
